import {gql } from '@apollo/client';

export const CREATE_BOOKING = gql`
  mutation CreateBooking($branchId : Int!,$input: BookingAppInput!) {
    createAppBooking(branchId : $branchId, input: $input) {
      id
      uuid
      status {
        id
        name
      }
      price
      notes
    }
  }
`;

export const CANCEL_BOOKING = gql`
  mutation CancelBooking($uuid: Uuid!, $branchId : Int!) {
    cancelAppBooking(branchId : $branchId, uuid: $uuid)
  }
`;

export const ADD_REVIEW = gql`
  mutation AddReview($reviewInput: ReviewInput!, $uuid: Uuid!) {
    leftReview(reviewInput: $reviewInput, uuid: $uuid)
  }
`;